<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>ID Scan PDF Report list</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between pb-2 pt-0"
            >
              <div class="d-md-flex justify-content-between">
                <div class="mr-0 mr-md-3 action-top-search">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      aria-label="Search"
                      aria-describedby="search"
                      v-model="searchText"
                      v-on:keyup.enter="refreshPartnerTable"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" id="search-mail">
                        <i class="icon-magnifier"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-md-flex justify-content-between">
                <b-button
                  size="lg"
                  variant="primary btn-mw"
                  v-b-modal.report_download
                >
                  Download Report
                </b-button>
              </div>
            </div>
            <b-modal id="report_download" title="Download Report" hide-footer>
              <div class="body">
                <div class="modal-area">
                  <ValidationObserver v-slot="{ passes }">
                    <form id="bank-form" @submit.prevent="passes(download)">
                      <div class="form-group datepicker">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From Date</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="download_report.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To Date</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="download_report.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div
                        class="align-items-center d-flex flex-column justify-content-between mt-3 w-100"
                      >
                        <b-button
                          type="submit"
                          variant="primary btn-mw"
                          size="lg"
                        >
                          Download
                        </b-button>
                        <b-button
                          @click="$bvModal.hide('report_download')"
                          size="lg"
                          variant="outline-secondary mt-3 btn-mw"
                        >
                          Cancel
                        </b-button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </b-modal>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Share and Save Coupon Listing -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  size="sm"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Download</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver } = require("vee-validate");
export default {
  name: "IDScanPDFReport",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    ValidationObserver,
  },
  data() {
    return {
      download_report: {
        from: "",
        to: "",
      },
      items: [
        {
          remitter_name: "Ben Murphy",
          file_name: "Passport",
          downloaded_by: "Selena Parker",
          date_from: "2024-05-20",
          date_to: "2024-06-20",
          downloaded_at: "2024-06-20",
          action: "",
        },
        {
          remitter_name: "Robert Evans",
          file_name: "Driving License",
          downloaded_by: "Jones Amegbor",
          date_from: "2024-05-11",
          date_to: "2024-06-20",
          downloaded_at: "2024-06-20",
          action: "",
        },
        {
          remitter_name: "Lusifer Boswell",
          file_name: "Passport",
          downloaded_by: "Selena Parker",
          date_from: "2024-01-20",
          date_to: "2024-04-02",
          downloaded_at: "2024-04-02",
          action: "",
        },
        {
          remitter_name: "Mark Richards",
          file_name: "Proof of Address",
          downloaded_by: "Selena Parker",
          date_from: "2024-05-20",
          date_to: "2024-06-20",
          downloaded_at: "2024-06-20",
          action: "",
        },
      ],
      searchText: "",

      fields: [
        {
          key: "file_name",
          label: "File Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "remitter_name",
          label: "Remitter Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "date_from",
          label: "From Date Time",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "date_to",
          label: "To Date Time",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "downloaded_at",
          label: "Downloaded At",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "downloaded_by",
          label: "Downloaded By",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-3",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      options: [],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    download() {
      console.log(this.download_report);
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
